import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { getNewsData } from "../api/dataSource";

export default function NewsMarquee() {
  const navigate = useNavigate();
  const [newsData, setNewsData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getNewsData();
      setNewsData(data);
    };
    fetchData();
  }, []);

  const handleNewsClick = (id) => {
    navigate(`/news?focus=${id}`);
  };

  return (
    <div className="w-full overflow-hidden">
      <div className="whitespace-nowrap animate-marquee text-white font-medium text-sm">
        {newsData && newsData.length > 0 ? (
          newsData.map((news) => (
            <span
              key={news.id}
              onClick={() => handleNewsClick(news.id)}
              className="mx-12 inline-flex items-center cursor-pointer hover:text-yellow-200 transition-colors"
            >
              📰 <span className="ml-2">{news.title}</span>
            </span>
          ))
        ) : (
          <span>📰 Loading news...</span>
        )}
      </div>
    </div>
  );
}